import React from "react";
import Page, { PageProps } from "../Page";
import { IDevicePresenter } from "../../../presenter/device/DevicePresenter";
import { DevicesConstants } from "../../../common/Constants";
import { Tooltip, Button } from "antd";
import DeviceTable from "../../components/device/DeviceTable";
import Header from "../../components/Header";
import { CloseOutlined } from "@ant-design/icons";

export interface Props extends PageProps {}
export interface State extends IDevicePresenter {}

export default class DeviceManagementPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      devices,
      translate,
      modalVisible,
      showModal,
      hideModal,
      selectedDevice,
      removeDevice,
      loaders,
      username,
      password,
      setUsername,
      setPassword,
      loginButtonDisabled
    } = this.state;

    const columns = [
      {
        title: translate("device_management_page.registration_date"),
        dataIndex: DevicesConstants.REGISTRATION_DATE,
        key: DevicesConstants.REGISTRATION_DATE
      },
      {
        title: translate("device_management_page.app_id"),
        dataIndex: DevicesConstants.APP_ID,
        key: DevicesConstants.APP_ID
      },
      {
        title: translate("device_management_page.description"),
        dataIndex: DevicesConstants.DESCRIPTION,
        key: DevicesConstants.DESCRIPTION
      },
      {
        title: "",
        dataIndex: DevicesConstants.REMOVE_DEVICE,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip
              title={translate("device_management_page.remove_device_button")}
            >
              <Button
                type="primary"
                danger={true}
                icon={<CloseOutlined />}
                onClick={() => showModal(record)}
                style={{ float: "right" }}
                size={"small"}
              />
            </Tooltip>
          </React.Fragment>
        )
      }
    ];

    return (
      <Page {...this.props}>
        <Header
          title={translate("pages.device_management")}
          buttonTitle={translate("login.logout")}
          buttonClick={() =>
            this.props.router.replace({
              pathname: `${import.meta.env.BASE_URL}device-logout`
            })
          }
          languagePickerVisible={false}
        />
        <div className="content-wrapper">
          <DeviceTable
            key="device-table-component"
            devices={devices}
            translate={translate}
            modalVisible={modalVisible}
            hideModal={hideModal}
            selectedDevice={selectedDevice}
            onConfirm={removeDevice}
            columns={columns}
            loading={loaders.removeDeviceLoader}
            username={username}
            password={password}
            onChangeUsername={setUsername}
            onChangePassword={setPassword}
            loginButtonDisabled={loginButtonDisabled}
          />
        </div>
      </Page>
    );
  }
}
